import type { QueryOptions } from '@apollo/client';

import type { Extension } from './graphql/types';
import { transformPreFilteredExtensions } from './hooks/lib/transformForgeExtensions';
import type {
	PreFilteredExtensionsQueryOptions,
	PrefilteredExtensionsResult,
	UsePreFilteredExtensionsQueryOptions,
} from './hooks/usePrefilteredExtensionList';
import { createUsePrefilteredExtensionListQueryOptions } from './hooks/usePrefilteredExtensionList';
import { FetchPreFilteredForgeAppsQuery } from './hooks/lib/queries';

export const preloadPrefilteredExtensionList = async <T>(
	query: <T, V>(options: QueryOptions<V>) => Promise<{ data: T | null }>,
	{
		cloudId,
		context,
		includeHidden,
		locale,
		types,
		queryOptions,
	}: UsePreFilteredExtensionsQueryOptions,
): Promise<Extension[] | null> => {
	const { fetchPolicy: _, ...requestOptions } =
		createUsePrefilteredExtensionListQueryOptions<PreFilteredExtensionsQueryOptions>(
			cloudId,
			context,
			undefined,
			types,
			locale,
			includeHidden,
			queryOptions,
		);

	const { data } = await query<PrefilteredExtensionsResult, PreFilteredExtensionsQueryOptions>({
		query: FetchPreFilteredForgeAppsQuery,
		...requestOptions,
	});

	const extensions = (data?.confluence_forgeExtensionsByType || []) as Extension[];
	if (extensions.length > 0) {
		return transformPreFilteredExtensions(extensions);
	}
	return null;
};
